<template>
	<card class="ReDashService theme">
		<!-- ,{'darkTheme':$GVO.my_profile.theme === 1 }, {'lightTheme':$GVO.my_profile.theme === 0 } -->
		<div class="row justify-content-between mx-0 mb-4">
			<h3>Услуга "{{objService.BP_NAME}}"</h3>
			<div class="bntGroup">
				<base-button type="primary" simple @click="gotoKanban(objService.BP_ID)">Задачи</base-button>
			</div>
		</div>
		<div class="serviceContent  mx-0">
			<div class="col col-md-2 newClients mt-2">
				<div class="zeroRow minicard cursor-pointer" @click="GoToServices('srv_sdelka=true')">
				    <p class="numbers">{{objService.serv_sdelka}}</p>
				    <p class="my-auto">Услуг в сделке</p>
				</div>
				<div class="frstRow minicard">
					<p class="numbers">{{itog_conversion}}%</p>
					<p>Общая конверсия</p>
				</div>
				<div class="onInWork minicard cursor-pointer" @click="GoToServices('srv_new=true&srv_inwork=true&srv_oncontrol=false')">
					<p class="numbers">{{objService.serv_in_work}}</p>
					<p>Сейчас в работе</p>
				</div>				
				<div class="onControl minicard dummy cursor-pointer" @click="GoToServices('srv_oncontrol=true')">
				    <p class="numbers">{{objService.all_on_control}}</p>
				    <p >Услуг на контроле</p>
				</div>
				<div class="lost minicard dummy cursor-pointer" @click="GoToServices('srv_arhiv=true&srv_oncontrol=false')">
				    <p class="numbers">{{objService.all_on_archive}}</p>
				    <p >Услуг в архиве/отказе</p>
				</div>
			</div>

			<div class="col col-lg-10 col-md-9 serviceStages">
				<div class="row my-2">
					<ReDashServiceStage v-for="(stage,si) in objService.jdata" :key="`${objService.BP_ID}_${si}`" :objStage="stage" :stages_json_list="objService.jdata_stage" :BP_ID="objService.BP_ID" :prev_objStage="lasrt_row(si)"/>
				</div>				
			</div>

		</div>

		<div class="">
			<!--base-button class="btn btn-simple btn-primary mt-0 mb-3 ml-2" @click="hideStats()">Показать причины отказов</base-button-->
			<base-button v-show="!isShown" class="btn btn-simple btn-primary mt-0 mb-3 ml-2" @click="getRejections()">Показать причины отказов</base-button>

			<div v-show="isShown">
				<div class="RejectionFlow mb-5" v-if="masRejection && masRejection.length>0">
					<div class="col-12  priceChart px-0">
						<card class="">
							<div class="chart-area">
								<pie-chart
								:labels="OlapChart.chartData.labels"
								:chart-data="OlapChart.chartData"
								:chart-options="OlapChart.chartOptions"
								:extra-options="OlapChart.extraOptions"
								:plugins="OlapChart.plugins"
								:height="this.chartHeight"
								
								>
								</pie-chart>
	
							</div>
						</card>
					</div>
				</div>
				
			</div>
		</div>

		<!--pre>{{objService}}</pre-->
	</card>
</template>

<script>
import ReDashServiceStage from 'src/our_components/ReDashServiceStage.vue';
import { /*Tooltip,*/ Button } from 'element-ui';
import PieChart from 'src/components/Charts/PieChart';
// import BarChart from 'src/components/Charts/BarChart';
// import * as chartConfigs from '@/components/Charts/config';
// import { Chart as Title, Legend, BarElement, CategoryScale, LinearScale } from '@/components/Charts/chart.js';
// ChartJS.register(Title,  Legend, BarElement, CategoryScale, LinearScale);
// import * as pieChartOptions from '@/components/Charts/config';



	export default {
		name: 'ReDashService',
		components: {
			ReDashServiceStage,	
			// Tooltip,
			[Button.name]: Button,
			PieChart,
			// BarChart,
			
		},
		props: {
			objService: Object,
			findId: {
				type: String,
				default: '',
			},
			serviceTitle: {
                type: String,
                default: 'Название',
            },
			
		},
		data () {
			return {
				ver: 1,
				objGetParams: {},
				isShown: false,
				masRejection: [],
				masColors: [],
				// masColors: '',
				chartHeight: 230,
				chartLegend: true,
				OlapChart: {
					chartData: {
						labels: [],
						datasets: [
							{
								label: 'Причина',
								backgroundColor: this.getRandomColor(),
								hoverBorderWidth: 6,
								data: [],
								
							}
						]
					},
					chartOptions: {
						// responsive: false,
						// maintainAspectRatio: false
					},
					extraOptions: {
						cutoutPercentage: 50,
						responsive: true,
						maintainAspectRatio: true
					},
					plugins: 
						{
							legend: {
								display: this.chartLegend,
								align: 'start',
								position: 'bottom',
								// maxHeight: 100,
								lineWidth: 4,
								labels: {
									// color: '#fff',
									font: {
										size: 18
									},
								},
								// fontColor: '#6679b0',
							},
						
						},
					
				},
			}
		},
		computed: {
			itog_conversion: function(){
				return this.$GVO.str_replace('.0','',((this.objService.serv_sdelka / this.objService.all_serv)*100).toFixed(1));
			}
		},
		methods: {
			gotoKanban(bp_id){
				if(typeof bp_id != 'undefined'){
					this.$router.push({path: '/data/tasks?ts=2&BP_ID='+bp_id});
				}
			},
			lasrt_row(si){
			    if(this.objService.jdata[si-1]!=undefined){
					return this.objService.jdata[si-1];
			    }else{
					return {'zero':{}};
			    }
			},
			GoToServices(status){
				this.objGetParams = this.$GVO.GetAllGet();
				for (const key in this.objGetParams) {
					if (Object.hasOwnProperty.call(this.objGetParams, key)) {
						if(key == 'p' || key == 'c2p' || key == 'bp_id' || key == 'stage_id' || (status.indexOf(key) != -1) ) {
							delete this.objGetParams[key];
						}
					}
				}
				let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1)+'&bp_id='+this.objService.BP_ID+'&'+status;
				//console.log(strItogGetParams);
				location.href = '/data/services?'+strItogGetParams;
			},
			getRejections() {
				let serv_list = [];
				if(this.objService.list_on_archive !='' || this.objService.list_on_archive != undefined) {
					for (let j = 0; j < this.objService.list_on_archive.length; j++) {
						const el = this.objService.list_on_archive[j];
						serv_list.push({serv_list_id: el});
						
					}
					
				}

				// console.log(serv_list);	

				this.$GVO.ApiCall('services.GET_SERVICE_ANAL_REJECTION',{flt:{'BP_ID':this.objService.BP_ID, serv_list: serv_list}})
					.then((objApi) => {
						if(objApi.success === true && objApi.data.length>0){
							//console.log(objApi);
							this.isShown = true;
							
							// for (let i = 0; i < objApi.data.length; i++) {
							// 	if(objApi.data[i].STATUS == 'В архиве' || objApi.data[i].STATUS == 'На контроле'){
							// 		const element = this.$GVO.unlinkObject(objApi.data[i]);
							// 		this.masRejection.push({STATUS: element.STATUS, counter: element.counter, nopurpose_text: element.nopurpose_text});
							// 	}				
							// }
							for (let i = 0; i < objApi.data.length; i++) {
								// if((objApi.data[i].STATUS == 'В архиве' || objApi.data[i].STATUS == 'На контроле')){}
									const element = this.$GVO.unlinkObject(objApi.data[i]);
									this.masRejection.push({STATUS: element.STATUS, counter: element.counter, nopurpose_text: element.nopurpose_text, serv_list_id: element.serv_list_id});
												
							}
							if(this.masRejection.length > 20){this.chartHeight = 450; this.chartLegend = false} else {this.chartHeight = 230;}
							this.setChartData();
						}else{
							this.masRejection = [];
						}
					}).catch(errorObjApi => {this.masRejection = []; console.error(errorObjApi);});
			},
			setChartData(){
				this.OlapChart.chartData.labels = [];
				this.OlapChart.chartData.datasets[0].data = [];
				for (let i = 0; i < this.masRejection.length; i++) {
					let rejection =  this.masRejection[i].nopurpose_text + '(' + this.masRejection[i].counter + ') ';
					// let rejection = '(' + this.masRejection[i].STATUS + ') ' + this.masRejection[i].nopurpose_text;
					// let rejection = this.masRejection[i].nopurpose_text;
					
					this.OlapChart.chartData.labels.push(rejection);
					this.OlapChart.chartData.datasets[0].data.push(this.masRejection[i].counter);
				}
			},
			getRandomColor() {
				let colorArr = [];
				for (let i = 0; i < 50; i++) {
					let letters = '0123456789ABCDEF'.split('');
					let color = '#';
					for (let j = 0; j < 6; j++ ) {
						color += letters[Math.floor(Math.random() * 16)];
					}
					colorArr.push(color);
					// console.log(color);
				}
				return colorArr;
			}
		},
		created(){
			this.objGetParams = this.$GVO.GetAllGet();
			// this.setChartData();
		},
		mounted(){

		}
	}
</script>
<style scoped>
.ReDashService {border: 1px solid #9e77f3;}
.ReDashService p {margin-bottom: 0px;}
.ReDashService h3 {margin-bottom: 7px;}
.serviceContent {display: flex; }
.newClients {border-right: 1px solid #2b3553; text-align: center; padding-left: 0; margin-bottom: 13px; padding-bottom: 13px;}
.results {border-left: 1px solid #2b3553; text-align: center; padding-right: 0;  margin-bottom: 13px;}
.results p { color: #fff;}

.minicard { border-radius: 6px; margin-bottom: 16px; }
.numbers {font-size: 30px; }
.frstRow,.zeroRow {display: flex; flex-direction: column; border: 1px solid #00bf9a;}
.zeroRow:hover {box-shadow: 0px 0px 10px rgba(158, 119, 243, 0.6);}
.zeroRow {border: 1px solid #9e77f3; background: #9e77f3;}
.zeroRow p {color: #fff;}
.ReDashService >>> .stageTitle:hover {box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.6)!important;}
/* .white-content .card:not(.card-white) .frstRow {box-shadow: none;} */
.frstRow.money {background-color:#00bf9a;}
.onControl {border: 1px solid#ff8d72; display: flex; align-items: center; flex-direction: column;}
.ReDashService >>> .onControl:hover {box-shadow: 0px 0px 10px rgba(255, 141, 114, 0.4);}
.onControl p:first-child, .lost p:first-child  {margin-right: 5px;}
.onInWork {border: 1px solid#728dFF; display: flex; align-items: center; flex-direction: column;}
.ReDashService >>> .onInWork:hover {box-shadow: 0px 0px 10px rgba(114, 141, 255, 0.4);}
.onInWork p:first-child, .lost p:first-child  {margin-right: 5px;}
.lost {border: 1px solid#f84e54; display: flex; align-items: center; flex-direction: column;}
.ReDashService >>> .lost:hover {box-shadow: 0px 0px 10px rgba(248, 78, 84, 0.4);} 
.dummy {min-height: 68px;}
.onControl.money {background-color:#ff8d72;}
.lost.money {background-color:#f84e54;}

:deep(body.white-content) .theme {background: #fff!important;}
:deep(body:not(.white-content)) .theme {background: #27293d!important;}
/* .ReDashService >>> .white-content .card:not(.card-white)  .lightTheme {background: #f84e54!important; }  */

.serviceStages .row {
	overflow-x: scroll; flex-wrap: nowrap;
}

.RejectionFlow {max-width: 700px;}

@media (max-width: 1201px){
	.priceChart {
		
	}
}
@media (max-width: 768px){
	.serviceContent {flex-direction: column;}
	.newClients {border-right: none; border-bottom: 1px solid #2b3553; margin-bottom: 15px; padding-bottom: 15px; padding-right: 0;}
	.results {border-left: none; border-top: 1px solid #2b3553; margin-top: 15px; padding-top: 15px; padding-left: 0;}	
	.minicard:last-child {margin-bottom: 0;}
	/*.lost, .onControl  {flex-direction: row; justify-content: center;}*/
	.serviceStages {padding-bottom: 8px;}
	.dummy {min-height: unset;}

	.ReDashService #pie-chart {height: 1000px!important;}
}

</style>
